import {ProductState} from "../../Products/interfaces/ProductComponentState";
import MarketRepository from "../repository/MarketRepository";
import {filter, find, get, size, sumBy, toNumber} from "lodash";
import GenerateUUID from "../../../utility/generateUUID";
import MarketCartLocalstorage from "../interface/MarketCartLocalstorage";
import {handleFatalError} from "../../../utility/errorHandler";
import AppSettingController from "./AppSettingController";
import marketSettingLocalStorage from "../interface/MarketSettingLocalStorage";
import i18n from "../../../i18n";

export default class AppCartController {

    static addItem(item: ProductState) {
        const prevItems = MarketRepository.getCartMarket();
        const isExistItem = AppCartController.isExistInCart(item);

        if (toNumber(get(isExistItem, "limit_add_to_cart", 0)) === get(isExistItem, "quantity", 1))
            return false;

        const updatedItems = prevItems.items.map((cartItem: any) => {
            const quantity = get(cartItem, "quantity", 1);
            if (quantity === undefined || quantity === null) {
                handleFatalError(i18n.t("table.countingProductFailedError"));
            }
            return cartItem._id === item._id
                ? {...cartItem, quantity: quantity + 1}
                : cartItem;
        });

        if (!isExistItem) {
            return MarketRepository.setCartMarket("items", [
                ...updatedItems,
                {...item, quantity: 1}
            ]);
        }

        return MarketRepository.setCartMarket("items", updatedItems);
    }

    static addCustomOrder(price: number) {
        const prevItems = MarketRepository.getCartMarket();

        const existingCustomOrder = find(prevItems.items, {customProduct: true, price});

        if (existingCustomOrder) {
            const updatedItems = prevItems.items.map((cartItem: any) => {
                const quantity = get(cartItem, "quantity", 1);
                if (quantity === undefined || quantity === null) {
                    handleFatalError(i18n.t("table.countingProductFailedError"));
                }
                return cartItem._id === existingCustomOrder._id
                    ? {...cartItem, quantity: quantity + 1}
                    : cartItem;
            });

            MarketRepository.setCartMarket("items", updatedItems);
            return true;
        }

        const customOrder = {
            limit_add_to_cart: "100",
            price: price,
            quantity: 1,
            total: 1000,
            status: true,
            customProduct: true,
            title: i18n.t("customOrder.title"),
            _id: GenerateUUID(),
        };

        MarketRepository.setCartMarket("items", [
            ...prevItems.items,
            customOrder
        ]);

        return this;
    }

    static removeItem(item: ProductState) {
        const prevItems = MarketRepository.getCartMarket();

        const isExistItem = AppCartController.isExistInCart(item);

        if (!isExistItem) return false;

        const updatedItems = prevItems.items.map((cartItem: any) => {
            const quantity = get(cartItem, "quantity", 1);
            if (quantity === undefined || quantity === null) {
                handleFatalError(i18n.t("table.countingProductFailedError"));
            }

            if (cartItem._id === item._id) {
                const updatedQuantity = quantity - 1;

                if (updatedQuantity <= 0) {
                    return null;
                }

                return {...cartItem, quantity: updatedQuantity};
            }
            return cartItem;
        }).filter((cartItem: any) => cartItem !== null);

        return MarketRepository.setCartMarket("items", updatedItems);
    }

    static clearCart() {
        return MarketRepository.setCartMarket("items", []);
    }

    static isExistInCart(item: ProductState) {
        const prevItems = MarketRepository.getCartMarket();
        return find(prevItems.items, {_id: item._id});
    }

    static extraCostsPrice() {
        const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;
        const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
        if (!setting.extraCosts?.length) return 0;


        const extraCosts = filter(setting.extraCosts || [], t => t.state !== "deactivate");

        const baseTotal = sumBy(card.items, item =>
            item.final_price ? toNumber(item.final_price):toNumber(item.price) * toNumber(get(item, "quantity", 1))
        );

        return sumBy(extraCosts, extraCost =>
            extraCost.type === "percentage"
                ? (baseTotal * toNumber(extraCost.extraCostsPercentage)) / 100
                : extraCost.type === "price"
                    ? toNumber(extraCost.extraCostsPrice)
                    : 0
        );
    }

    static priceSum(ByExtraCosts: boolean = false) {
        const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;
        const setting = AppSettingController.getSetting() as marketSettingLocalStorage;

        const extraCostsLis = filter(setting.extraCosts || [], t => t.state !== "deactivate");

        const baseTotal = sumBy(card.items, item =>
             toNumber(item.final_price ? item.final_price : toNumber(item.price))  * toNumber(get(item, "quantity", 1))
        );

        const extraCosts = sumBy(extraCostsLis, extraCost =>
            extraCost.type === "percentage"
                ? (baseTotal * toNumber(extraCost.extraCostsPercentage)) / 100
                : extraCost.type === "price"
                    ? toNumber(extraCost.extraCostsPrice)
                    : 0
        );

        if (setting.extraCosts?.length && ByExtraCosts)
            return baseTotal + extraCosts;

        return baseTotal;
    }
}
